var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4955 9.9754H21.5265M31.4955 1.25253H1.5885M31.4955 19.1136H21.5265M31.4955 27.8365H1.5885M4.2469 21.1905H12.2221C13.1526 21.1905 13.6179 21.1905 13.9733 21.0094C14.2859 20.8501 14.5401 20.596 14.6994 20.2833C14.8805 19.9279 14.8805 19.4626 14.8805 18.5321V10.5569C14.8805 9.6264 14.8805 9.16114 14.6994 8.80572C14.5401 8.49309 14.2859 8.23892 13.9733 8.07962C13.6179 7.89853 13.1526 7.89853 12.2221 7.89853H4.2469C3.31637 7.89853 2.85111 7.89853 2.4957 8.07962C2.18306 8.23892 1.92889 8.49309 1.76959 8.80572C1.5885 9.16114 1.5885 9.6264 1.5885 10.5569V18.5321C1.5885 19.4626 1.5885 19.9279 1.76959 20.2833C1.92889 20.596 2.18306 20.8501 2.4957 21.0094C2.85111 21.1905 3.31637 21.1905 4.2469 21.1905Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentScore);
export default __webpack_public_path__ + "static/media/assessment_score.b80f1b70685a127ce1fe6603c6d3ec6b.svg";
export { ForwardRef as ReactComponent };